import { Link } from 'react-router-dom'
import type { ComponentProps } from 'react'

// MDX renders `[text](href)` as <a>. Override that so internal paths use
// react-router (no full page reload) and external links pick up
// target=_blank + rel=noopener noreferrer automatically.
export default function MdxLink({
  href,
  children,
  ...rest
}: ComponentProps<'a'>) {
  if (!href) {
    return <a {...rest}>{children}</a>
  }

  const isExternal =
    /^https?:\/\//.test(href) ||
    href.startsWith('mailto:') ||
    href.startsWith('tel:')

  if (isExternal) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    )
  }

  return <Link to={href}>{children}</Link>
}
